export default __webpack_public_path__ + "static/media/annex12.70cbe545.png";